<template>
  <ModalPrimary
    v-bind="modalAttrs"
    :name="modalName"
    @before-open="beforeModalOpen"
  >
    <div :style="containerStyle">
      <HeaderLargePrimary :style="headerStyle">
        Share "{{ tenantTeamName }}"
      </HeaderLargePrimary>
      <!--
      <div :style="innerContainerStyle">
        <TextRegular>
          Anyone in "{{ tenantName }}" workspace can view "{{ tenantTeamName }}" with this link.
        </TextRegular>
        <div :style="copyFormContainerStyle">
          <InputTextPrimary
            v-model="viewTenantTeamUrl"
            :disabled="true"
          />
        </div>
        <div :style="copyButtonContainerStyle">
          <ButtonPrimary
            :style="copyButtonStyle"
            @click="copyLink"
          >
            Copy link
          </ButtonPrimary>
        </div>
      </div>
      -->
      <div :style="{ width: '100%' }">
        <TextRegular>
          Please enter the email of the coworker with whom you want to share the team.
        </TextRegular>
        <div :style="inputContainerStyle">
          <InputTextSecondary
            v-model="input"
            placeholder="Enter email address"
            :style="inputStyle"
          />
          <ButtonPrimary
            :disabled="disableShareButton"
            :style="shareButtonStyle"
            @click="createTenantTeamPermission"
          >
            Share
          </ButtonPrimary>
        </div>
        <div :style="permissionsContainerStyle">
          <div
            v-for="(permission, index) in tenantTeamPermissions"
            :key="index"
            :style="permissionContainerStyle"
          >
            <div :style="permissionUserContainerStyle">
              <UserImagePrimary
                :tenantUser="permission.tenantUser"
                :style="userImageStyle"
              />
              <TextRegular :truncate="true">
                {{ permission.tenantUser.user.firstName }} {{ permission.tenantUser.user.lastName }}
              </TextRegular>
            </div>
            <TextButtonSmallWarning
              v-if="permission.permissionType !== 100"
              @click="deleteTenantTeamPermission(permission.id)"
            >
              delete
            </TextButtonSmallWarning>
          </div>
        </div>
      </div>
      <div :style="buttonsContainerStyle">
        <ButtonSecondary
          :style="cancelButtonStyle"
          @click="cancel"
        >
          Cancel
        </ButtonSecondary>
      </div>
    </div>
  </ModalPrimary>
</template>

<script>
  import ApiTenantTeamPermission from '@js/api/tenant-team-permission'
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import HttpStatus from 'http-status-codes'
  //import InputTextPrimary from '@modules/input/input-text-primary'
  import InputTextSecondary from '@modules/v2/input/input-primary'
  import ModalPrimary from '@modules/modal/modal-primary'
  import TextButtonSmallWarning from '@modules/v2/button/text-button-small-warning'
  import TextRegular from '@modules/v2/text/text-regular'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'
  import { validateEmail } from '@js/str-utils'

  export default {
    name: 'ModalShareTenantTeamLink',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      //InputTextPrimary,
      InputTextSecondary,
      ModalPrimary,
      TextRegular,
      TextButtonSmallWarning,
      UserImagePrimary,
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'flex-end',
          display: 'flex',
          justifyContent: 'flex-start',
          width: '100%',
        },
        cancelButtonStyle: {
          minWidth: '80px',
        },
        containerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '500px',
          justifyContent: 'space-between',
          width: '100%',
        },
        copyButtonContainerStyle: {
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
        },
        copyButtonStyle: {
          margin: `${Layout.space.md} 0 0 0`,
          minWidth: '96px',
        },
        copyFormContainerStyle: {
          margin: `${Layout.space.lg} 0 0 0`,
        },
        headerStyle: {
          lineHeight: FontStyle.size.lg,
        },
        innerContainerStyle: {
          width: '100%',
        },
        input: '',
        inputContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          margin: `${Layout.space.md} 0 0 0`,
          width: '100%',
        },
        inputStyle: {
          width: '100%',
        },
        isRequesting: false,
        modalAttrs: {
          maxWidth: 480,
          minHeight: 400,
        },
        modalName: MODAL_WINDOW_NAMES.SHARE_TENANT_TEAM_LINK_PRIMARY,
        permissionContainerStyle: {
          display: 'flex',
          height: '32px',
          margin: `10px 0 0 0`,
          width: '100%',
        },
        permissionsContainerStyle: {
          height: 'fit-content',
          margin: `${Layout.space.xs} 0 0 0`,
          maxHeight: '280px',
          overflowY: 'scroll',
          width: '100%',
        },
        permissionStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
        permissionUserContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flex: 1,
        },
        shareButtonStyle: {
          margin: `0 0 0 ${Layout.space.md}`,
          minWidth: '84px',
        },
        tenantName: '',
        tenantTeamName: '',
        tenantTeamPermissions: [],
        tenantTeamPermissionsUpdated: false,
        userImageStyle: {
          margin: `0 ${Layout.space.sm}`,
        },
        code: '',
        viewTenantTeamUrl: '',
      };
    },
    created: function () {
      const baseUrl = process.env.VUE_APP_API_SERVER_BASE_URL + ':' + process.env.VUE_APP_API_SERVER_PORT;
      const protocol = baseUrl.includes('localhost') ? 'http' : 'https';
      this.viewTenantTeamUrl = `${protocol}:${baseUrl}/teamup`;
    },
    computed: {
      disableShareButton: function () {
        return !validateEmail(this.input) || this.isRequesting;
      },
    },
    methods: {
      beforeModalOpen: function (e) {
        this.tenantTeamName = e.params ? (e.params.tenantTeamName ? e.params.tenantTeamName : '') : '';

        this.tenantName = e.params ? (e.params.tenantName ? e.params.tenantName : '') : '';
        this.code = e.params ? (e.params.code ? e.params.code : '') : '';
        this.tenantTeamPermissions = e?.params?.tenantTeamPermissions != null ? e.params.tenantTeamPermissions : [];
        this.isRequesting = false;
        this.viewTenantTeamUrl = `${this.viewTenantTeamUrl}/${this.code}/view`;
      },
      cancel: function () {
        this.close();
      },
      clear: function () {
        const baseUrl = process.env.VUE_APP_API_SERVER_BASE_URL + ':' + process.env.VUE_APP_API_SERVER_PORT;
        const protocol = baseUrl.includes('localhost') ? 'http' : 'https';

        this.tenantTeamName = '';
        this.tenantTeamPermissions = [];
        this.tenantName = '';
        this.code = '';
        this.isRequesting = false;
        this.viewTenantTeamUrl = `${protocol}:${baseUrl}/teamup`;
      },
      close: function () {
        this.clear();
        if (this.tenantTeamPermissionsUpdated) {
          this.$emit('updated-tenant-team-permissions');
        }
        this.$modal.hide(this.modalName);
      },
      copyLink: function () {
        navigator.clipboard.writeText(this.viewTenantTeamUrl);
        this.$store.commit('notification/setMessage', 'Copied Link');
      },
      createTenantTeamPermission: async function () {
        try {
          this.isRequesting = await true;
          const payload = {
            tenantTeamCode: this.code,
            email: this.input,
            permissionType: 0,
          };
          const api = await new ApiTenantTeamPermission(this.code);
          const res = await api.post(payload);
          await this.tenantTeamPermissions.push(res.data);
          this.tenantTeamPermissionsUpdated = await true;
          await this.$store.commit(
            'notification/setMessage',
            `Share with ${res.data.tenantUser.user.firstName} ${res.data.tenantUser.user.lastName}`,
          );
          this.input = await '';
        } catch (error) {
          if (
            error?.response?.status === 409 ||
            error?.response?.status === 404
          ) {
            this.$store.commit(
              'notification/setWarning',
              error?.response?.data?.messages[0],
            );
          }
          console.error(error);
        } finally {
          this.isRequesting = false;
        }
      },
      deleteTenantTeamPermission: async function (tenantTeamPermissionId) {
        try {
          this.isRequesting = await true;
          const api = await new ApiTenantTeamPermission(this.code, tenantTeamPermissionId);
          const res = await api.delete();

          const index = this.tenantTeamPermissions.findIndex(
            elem => elem.id === res.data.id);
          if (index !== -1) {
            this.tenantTeamPermissions.splice(index, 1);
          }
          this.tenantTeamPermissionsUpdated = await true;
          this.$store.commit(
            'notification/setMessage',
            `Stopped sharing with ${res.data.tenantUser.user.firstName} ${res.data.tenantUser.user.lastName}`,
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.isRequesting = false;
        }
      },
    },
  };
</script>
